<template>
  <div class="box-card" shadow="never"
       :body-style="{ backgroundColor: '#F6F8FB', padding: '0' }">

    <ul class="scroll-items">
      <li v-for="(shourtcut) in shortcuts" :class="shourtcut.id === selectShortcutId ? 'li-active' : ''"  @click="shourtcutSelect(shourtcut.id)">
        <el-popover
            placement="right"
            trigger="hover"
           >
          <div slot="default" style="padding: 8px 16px;" v-if="shourtcut.id !== 'project_fill_in_pass_rate'">
            共{{ shourtcut.count }}单
          </div>
          <div slot="reference" style="display: flex;align-items: center;">
            <img v-if="shourtcut.id === selectShortcutId" src="../../../assets/img/arrow_select.png" width="5" height="27">
            <img v-else src="../../../assets/img/arrow-none.png" width="5" height="27">

            <div class="text">
              {{ shourtcut.title }}
            </div>
          </div>
        </el-popover>


      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CustomDrawer",
  // props:["items"],
  props:["selectShortcutIdProps","shortcuts"],
  data(){
    return {
      selectShortcutId:"all",
      // itemSelectID:0,
      // leftItems:[
      //   {
      //     id:0,
      //     name:"业绩表现",
      //     key:"performance"
      //   },
      //   {
      //     id:1,
      //     name:"企业资产",
      //     key:"asset"
      //   }
      // ],
    }
  },
  // methods:{
  //   leftAsideItemClick(item,idx){
  //     console.log('leftAsideItemClick',item.id)
  //     this.itemSelectID = item.id
  //     this.$emit('selectChange',item.key)
  //   }
  // }
  mounted() {
    this.selectShortcutId = this.selectShortcutIdProps
  },

  watch:{
    selectShortcutIdProps(newVal){
      console.log('selectShortcutIdProps',newVal)
      this.selectShortcutId = newVal
    }
  },

  methods:{
    shourtcutSelect(key){
      this.$emit("shourtcutSelectChange",key)
    }
  }
}
</script>

<style scoped lang="scss">
.scroll-items{
  height: calc(100% - 25px);
}
.box-card {
  width: 100%;
  height: 100%;

ul {
  //height: 100% !important;
  overflow-y: auto;

li {
  position: relative;
//width: 272px;
  font-size: 16px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: #3F464E;
  //border-bottom: 1px solid rgba(213, 215, 223, .5);
// &:last-of-type{
    //   border: none;
    // }
cursor: default;

&:hover {
   cursor: pointer;
   background: #EBEFF7;
 }

.text {

  display: flex;
  align-items: center;
  text-align: center;
  //height:41px;
  font-size: 12px;
  padding:4px 10px 3px 6px;
.el-input .el-input__count .el-input__count-inner {
  background: none;
}

.el-input__inner {
  height: 50px;
//width: 272px;
  background: #EBEFF7;
  border: none;
// border-left:1px solid rgba(57, 148, 241, .5);
  font-size: 16px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  border-radius: 0;
// color: #3994F1;
}

input::-webkit-input-placeholder {
  font-size: 16px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: rgba(57, 148, 241, .4);
}

.dot {
  width: 10px;
  height: 10px;
  margin-right: 6px;
}
}

.btn {
  position: absolute;
  right: 30px;
  top: 19px;
}

}

.li-active {
  background-color: #E6E9EE;
  color: #909399;

&:hover {
   background-color: #E6E9EE;
  opacity: .6;
 }
}
}
}
</style>
